// import serviceConnections from "../../assets/images/IMG-2.png";
// import serviceDigital from "../../assets/images/IMG-3.png";
// import serviceFinance from "../../assets/images/IMG-4.png";
// import serviceDelivery from "../../assets/images/IMG-5.png";
// import { useLanguage } from "../../contexts/LanguageContext"; 

// // import serviceConnections from "../../assets/images/IMG-5.png";
// // import serviceDigital from "../../assets/images/IMG-2.png";
// // import serviceFinance from "../../assets/images/IMG-4.png";
// // import serviceDelivery from "../../assets/images/IMG-3.png";

// import "./Services.css";

// const services = [
//   {
//     number: "1",
//     title: "Nationwide Connections",
//     description: "Access a vast network of trusted yarn suppliers and buyers tailored to your needs.",
//     image: serviceConnections,
//   },
//   {
//     number: "2",
//     title: "Digital Experts",
//     description: "Benefit from our digital platform for fair and transparent deals.",
//     image: serviceDigital,
//   },
//   {
//     number: "3",
//     title: "Trade Finance",
//     description: "Access financial flexibility through our lending partners who offer trade credit and financing options tailored for your business.",
//     image: serviceFinance,
//   },
//   {
//     number: "4",
//     title: "Digital Experts",
//     description: "From sourcing to final delivery, we support every stage of your yarn supply chain. With real-time tracking, optimized logistics, and reliable inventory flow.",
//     image: serviceDelivery,
//   },
// ];

// const Services = () => {
//   const { language } = useLanguage();
//   return (
//     <section id="services" className="services-section">
//       <div className="container">
//         <div className="services-header">
//           <h2 className="services-header__title">
//             WHAT Services WE'RE <span>OFFERING..</span>
//           </h2>
//         </div>

//         <div className="services-grid">
//           {services.map((service) => (
//             <div key={service.number} className="service-card">
//               <div className="service-card__image-wrapper">
//                 <img
//                   src={service.image}
//                   alt={service.title}
//                   className="service-card__image"
//                 />
//               </div>
//               <span className="service-card__number">{service.number}</span>
//               <div className="service-card__content bg-white">
//                 <h3 className="service-card__title">{service.title}</h3>
//                 <p className="service-card__description">{service.description}</p>
//                 <div className="service-card__accent-bar" />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Services;

import serviceConnections from "../../assets/images/IMG-2.png";
import serviceDigital from "../../assets/images/IMG-3.png";
import serviceFinance from "../../assets/images/IMG-4.png";
import serviceDelivery from "../../assets/images/IMG-5.png";

import { useLanguage } from "../../contexts/LanguageContext";
import "./Services.css";

const images = [
  serviceConnections,
  serviceDigital,
  serviceFinance,
  serviceDelivery,
];

const Services = () => {
  const { t } = useLanguage();

  // get items array from json
  const services = t("whatWeOffer.items", { returnObjects: true });

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="services-header">
          <h2 className="services-header__title">
            {t("whatWeOffer.title")}
          </h2>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-card__image-wrapper">
                <img
                  src={images[index]}
                  alt={service.title}
                  className="service-card__image"
                />
              </div>

              {/* <span className="service-card__number">
                {index + 1}
              </span> */}

              <div className="service-card__content bg-white">
                <h3 className="service-card__title">
                  {service.title}
                </h3>

                <p className="service-card__description">
                  {service.content}
                </p>

                <div className="service-card__accent-bar" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;